module.exports = __webpack_public_path__ + "static/185_gan-8cfd336ddc958723fa52fb258d385816.jpg";